import { Component, computed, EventEmitter, inject, Inject, Output, signal, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BottomSheetSaveCancelComponent } from 'src/app/components/bottom-sheet-save-cancel/bottom-sheet-save-cancel.component';
import { DataService } from 'src/app/services/data.service';
import { GridService } from 'src/app/services/controls/grid.service';
import { DialogData } from 'src/app/types/infrastructure/interfaces/IDialogData';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { IPreissteigerung } from 'src/app/types/IPreissteigerung';
import { IPreissteigerungProzent } from 'src/app/types/IPreissteigerungProzent';
import { DataChange } from 'devextreme-angular/common/grids';
import { AppstateService } from 'src/app/services/appstate.service';
import { DialogService } from 'src/app/services/dialog.service';
import { IPreissteigerungDialogData } from 'src/app/types/infrastructure/interfaces/IPreissteigerungDialogData';
import { IBudgetantragKosten } from 'src/app/types/IBudgetantragKosten';
import { IBudgetantrag } from 'src/app/types/IBudgetantrag';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-budget-preissteigerung',
  standalone: false,
  // imports: [],
  templateUrl: './budget-preissteigerung.component.html',
  styleUrl: './budget-preissteigerung.component.css',
  providers: [GridService]
})
export class BudgetPreissteigerungComponent {

  @ViewChild("gridPreissteigerung", { static: false })
  public grid!: DxDataGridComponent;

  public dataPreissteigerung = computed<IPreissteigerungProzent[] | null>(() => this.dataService.budgetantragPreissteigerung());
  public dataPreissteigerungKalkulation = computed<IBudgetantragKosten[] | null>(() => this.dataService.budgetantragPreissteigerungKosten());
  public columnWidth = computed<number>(() => this.data?.offset ? 110 : 100);
  public initialized = signal<boolean>(false);
  public dataBudgetantrag = computed<IBudgetantrag | null>(() => this.dataService.budgetantragDetails());
  public allowEdit = computed(() => !this.dataBudgetantrag()!.freigabeFinal && this.userService.AllowEdit(this.dataBudgetantrag()!.aktuelleBearbeitung, this.dataBudgetantrag()!.antragstellerID, this.dataBudgetantrag()!.pstID, this.dataBudgetantrag()!.pmID));

  private bottomSheetRef = inject<MatBottomSheetRef<BottomSheetSaveCancelComponent>>(MatBottomSheetRef);
  private readonly data = inject<IPreissteigerungDialogData>(MAT_BOTTOM_SHEET_DATA);
 
  constructor(private dataService: DataService,
              private appStateService: AppstateService,
              private dialogService: DialogService,
              private userService: UserService,
              public gridService: GridService) {

    this.onGridRowPopupButtonClick = this.onGridRowPopupButtonClick.bind(this);
    this.onGridRowEditButtonClick = this.onGridRowEditButtonClick.bind(this);
    this.isGridRowPopupButtonVisible = this.isGridRowPopupButtonVisible.bind(this);
    this.isGridRowEditButtonVisible = this.isGridRowEditButtonVisible.bind(this);            

  }

  ngOnInit() {
    this.gridService.Bezugsjahr.set(this.data.bezugsjahr!);
  }

  onCloseClick() {
    this.bottomSheetRef.dismiss({
      action: 'Cancel',
    });
  }

  onGridInitialized(e: any) {
    this.grid.instance.option('editing.mode', 'row');
  }

  onGridContentReady(e: any) {
    if (this.allowEdit() == false) return;

    if (this.initialized() == false) {
      this.grid.instance.editRow(0);
      this.initialized.set(true);
    }
  }

  onGridCellPrepared(e: any) {

    if(e.rowType === "data") {
      // data rows

      if(e.column.dataField === "jahr0Prozent") {
        if (e.value !== e.data.jahr0ProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      } else if(e.column.dataField === "jahr1Prozent") {
        if (e.value !== e.data.jahr1ProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      } else if(e.column.dataField === "jahr2Prozent") {
        if (e.value !== e.data.jahr2ProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      } else if(e.column.dataField === "jahr3Prozent") {
        if (e.value !== e.data.jahr3ProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      } else if(e.column.dataField === "jahr4Prozent") {
        if (e.value !== e.data.jahr4ProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      } else if(e.column.dataField === "jahr5Prozent") {
        if (e.value !== e.data.jahr5ProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      } else if(e.column.dataField === "jahrZukunftProzent") {
        if (e.value !== e.data.jahrZukunftProzentDefault) {
          e.cellElement.classList.add("dx-data-warning")
        } else {
          e.cellElement.classList.remove("dx-data-warning")
        }
      }

      if (e.row.isEditing) {
        // Validate required fields while editing row
        if(e.column.dataField === "abweichungBegruendung") {
          if (e.data.jahr0Prozent !== e.data.jahr0ProzentDefault ||
              e.data.jahr1Prozent !== e.data.jahr1ProzentDefault ||
              e.data.jahr2Prozent !== e.data.jahr2ProzentDefault ||
              e.data.jahr3Prozent !== e.data.jahr3ProzentDefault ||
              e.data.jahr4Prozent !== e.data.jahr4ProzentDefault ||
              e.data.jahr5Prozent !== e.data.jahr5ProzentDefault ||
              e.data.jahrZukunftProzent !== e.data.jahrZukunftProzentDefault) {
                if (e.value == undefined || e.value == "") {
                  e.cellElement.classList.add("dx-datagrid-invalid"); 
                }
          } else {
            e.cellElement.classList.remove("dx-datagrid-invalid");
          }
        }
      } 
    }
  }

  validateGridAbweichungsbegruendung(e: any) {
    if ((e.data.jahr0Prozent !== e.data.jahr0ProzentDefault ||
         e.data.jahr1Prozent !== e.data.jahr1ProzentDefault ||
         e.data.jahr2Prozent !== e.data.jahr2ProzentDefault ||
         e.data.jahr3Prozent !== e.data.jahr3ProzentDefault ||
         e.data.jahr4Prozent !== e.data.jahr4ProzentDefault ||
         e.data.jahr5Prozent !== e.data.jahr5ProzentDefault ||
         e.data.jahrZukunftProzent !== e.data.jahrZukunftProzentDefault)) {
      if (e.value == null || e.value == "") {
        return false;
      }
    }
    return true;
  }  

  onGridTextareaValueChanged(e: any, cellInfo: any, dropDownBoxComponent: any) {
    var text = e.value;
      cellInfo.setValue(text);
      dropDownBoxComponent.close();
  }

  onGridRowEditButtonClick(e: any) { 
    if (e.row.rowType === "data") {
      this.grid.instance.option('editing.mode', 'row');
      this.grid.instance.editRow(e.row.rowIndex);
    }
  }

  onGridRowPopupButtonClick(e: any) {  
    this.grid.instance.option('editing.mode', 'popup');
    if (e.row.rowType === "data") {
      this.grid.instance.editRow(e.row.rowIndex);
    }
  }

  onGridRowDblClick(e: any) {
    if (this.allowEdit() == false) return;

    if (e.rowType === "data") {
      this.grid.instance.option('editing.mode', 'row');
      this.grid.instance.editRow(e.rowIndex);
    }
  }
  
  isGridRowEditButtonVisible(e: any) {
    if (this.allowEdit() == false) return false;

    if (e.row.rowType === "data") {
      if (e.row.isEditing) return false;
    }
    return true;
  }

  isGridRowPopupButtonVisible(e: any) {
    if (this.allowEdit() == false) return false;

    if (e.row.rowType === "data") {
      if (e.row.isEditing) return false;
    }
    return true;
  }

  isGridEditModeRow() {
    return (this.grid && this.grid.instance.option('editing.mode') == 'row');
 }  
  setGridCellValueDefault(this: any, newData: IPreissteigerung, value: number, currentRowData: IPreissteigerung) {
    if (this.defaultSetCellValue) this.defaultSetCellValue(newData, value, currentRowData);
  }

  onGridRowSaving(e: any) {
    if (e.changes.length == 0) {
      e.cancel = true;
    } 
  }

  onGridRowSaved(e: any) {
    e.changes.forEach((row: DataChange) => {
      if (row.type === "update") {
        this.dataService.updateBudgetantragPreissteigerung(this.appStateService.budgetantragId(), row.data).subscribe({
          next: (data) => {
            this.dialogService.showMessageSheet('Die Preissteigerung wurde erfolgreich aktualisiert.');
          }
        }); 
      } 
    });
  }

  closeClick(): void {
    this.bottomSheetRef.dismiss({
      action: 'Cancel',
    });
  }

}
